import { apiRequest, qs } from "@/lib/api";

export const CONTENT_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "ready", label: "Ready to Post" },
  { key: "captions", label: "Captions" },
  { key: "stories", label: "Story Templates" },
  { key: "spotlights", label: "Product Spotlights" },
  { key: "launches", label: "Launches & Offers" },
  { key: "ideas", label: "Content Ideas" },
];

export const EDITABLE_CATEGORIES = CONTENT_CATEGORIES.filter((c) => c.key !== "all");

export const CATEGORY_LABEL = {
  ready: "Ready to Post",
  captions: "Caption",
  stories: "Story Template",
  spotlights: "Product Spotlight",
  launches: "Launch",
  ideas: "Content Idea",
};

export const CATEGORY_ICON = {
  ready: "image",
  captions: "message-circle",
  stories: "smartphone",
  spotlights: "star",
  launches: "gift",
  ideas: "video",
};

export const contentApi = {
  list: () => apiRequest("/content"),
  adminList: (token) => apiRequest("/admin/content", { token }),
  adminGet: (id, token) => apiRequest(`/admin/content/${id}`, { token }),
  adminCreate: (body, token) => apiRequest("/admin/content", { method: "POST", body, token }),
  adminUpdate: (id, body, token) => apiRequest(`/admin/content/${id}`, { method: "PUT", body, token }),
  adminDelete: (id, token) => apiRequest(`/admin/content/${id}`, { method: "DELETE", token }),
};

export const shopifyApi = {
  status: () => apiRequest("/shopify/status"),
  products: (first = 24) => apiRequest(`/shopify/products?first=${first}`),
  adminGetConfig: (token) => apiRequest("/admin/shopify-config", { token }),
  adminSetConfig: (body, token) => apiRequest("/admin/shopify-config", { method: "PUT", body, token }),
};

export function formatPrice(p) {
  if (!p.price) return "";
  const n = Number(p.price);
  const amount = Number.isFinite(n) ? n.toFixed(2) : p.price;
  return p.currency ? `${amount} ${p.currency}` : amount;
}

// ---- Crystals ----
export const crystalsApi = {
  meta: () => apiRequest("/crystals/meta"),
  list: (p = {}) => apiRequest(`/crystals${qs(p)}`),
  get: (slug) => apiRequest(`/crystals/${slug}`),
  favourites: (token) => apiRequest("/me/favourites", { token }),
  addFavourite: (id, token) => apiRequest(`/me/favourites/${id}`, { method: "POST", token }),
  removeFavourite: (id, token) => apiRequest(`/me/favourites/${id}`, { method: "DELETE", token }),
  adminList: (token, search) => apiRequest(`/admin/crystals${qs({ search })}`, { token }),
  adminGet: (id, token) => apiRequest(`/admin/crystals/${id}`, { token }),
  adminCreate: (body, token) => apiRequest("/admin/crystals", { method: "POST", body, token }),
  adminUpdate: (id, body, token) => apiRequest(`/admin/crystals/${id}`, { method: "PUT", body, token }),
  adminDelete: (id, token) => apiRequest(`/admin/crystals/${id}`, { method: "DELETE", token }),
};

const RECENT_KEY = "ritzyra_recent_crystals";
export function getRecentCrystals() {
  try {
    const parsed = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
    return Array.isArray(parsed) ? parsed.slice(0, 8) : [];
  } catch {
    return [];
  }
}
export function pushRecentCrystal(c) {
  const list = getRecentCrystals();
  const next = [c, ...list.filter((x) => x.slug !== c.slug)].slice(0, 8);
  localStorage.setItem(RECENT_KEY, JSON.stringify(next));
}

// ---- Lab ----
export const labApi = {
  home: () => apiRequest("/lab"),
  get: (slug) => apiRequest(`/lab/${slug}`),
  getAnswers: (slug, token) => apiRequest(`/me/lab/${slug}`, { token }),
  saveAnswers: (slug, answers, token) => apiRequest(`/me/lab/${slug}`, { method: "PUT", body: { answers }, token }),
  setComplete: (slug, completed, token) => apiRequest(`/me/lab/${slug}/complete`, { method: "POST", body: { completed }, token }),
  adminList: (token) => apiRequest("/admin/lab", { token }),
  adminGet: (id, token) => apiRequest(`/admin/lab/${id}`, { token }),
  adminSaveLanding: (body, token) => apiRequest("/admin/lab/landing", { method: "PUT", body, token }),
  adminCreate: (body, token) => apiRequest("/admin/lab", { method: "POST", body, token }),
  adminUpdate: (idWithQuery, body, token) => apiRequest(`/admin/lab/${idWithQuery}`, { method: "PUT", body, token }),
  adminDelete: (id, token) => apiRequest(`/admin/lab/${id}`, { method: "DELETE", token }),
};

// ---- affiliates + password reset ----
export const affiliatesApi = {
  list: (token) => apiRequest("/admin/affiliates", { token }),
  invite: (body, token) => apiRequest("/admin/affiliates/invite", { method: "POST", body, token }),
  resend: (email, token) => apiRequest(`/admin/affiliates/resend/${encodeURIComponent(email)}`, { method: "POST", token }),
  activate: (email, token) => apiRequest(`/admin/affiliates/${encodeURIComponent(email)}/activate`, { method: "POST", token }),
  deactivate: (email, token) => apiRequest(`/admin/affiliates/${encodeURIComponent(email)}/deactivate`, { method: "POST", token }),
  revoke: (email, token) => apiRequest(`/admin/affiliates/${encodeURIComponent(email)}`, { method: "DELETE", token }),
};
